export const PAYLOAD_PACKAGE_LIST = [
  'payload',
  '@payloadcms/bundler-vite',
  '@payloadcms/bundler-webpack',
  '@payloadcms/db-d1-sqlite',
  '@payloadcms/db-mongodb',
  '@payloadcms/db-postgres',
  '@payloadcms/db-sqlite',
  '@payloadcms/db-vercel-postgres',
  '@payloadcms/drizzle',
  '@payloadcms/ecommerce',
  '@payloadcms/email-nodemailer',
  '@payloadcms/email-resend',
  '@payloadcms/graphql',
  '@payloadcms/live-preview',
  '@payloadcms/live-preview-react',
  '@payloadcms/live-preview-vue',
  '@payloadcms/kv-redis',
  '@payloadcms/next/utilities',
  '@payloadcms/payload-cloud',
  '@payloadcms/plugin-cloud-storage',
  '@payloadcms/plugin-form-builder',
  '@payloadcms/plugin-import-export',
  '@payloadcms/plugin-mcp',
  '@payloadcms/plugin-multi-tenant',
  '@payloadcms/plugin-nested-docs',
  '@payloadcms/plugin-redirects',
  '@payloadcms/plugin-search',
  '@payloadcms/plugin-seo',
  '@payloadcms/plugin-stripe',
  '@payloadcms/plugin-zapier',
  '@payloadcms/richtext-lexical',
  '@payloadcms/richtext-slate',
  '@payloadcms/sdk',
  '@payloadcms/storage-azure',
  '@payloadcms/storage-gcs',
  '@payloadcms/storage-r2',
  '@payloadcms/storage-s3',
  '@payloadcms/storage-uploadthing',
  '@payloadcms/storage-vercel-blob',
  '@payloadcms/translations',
  '@payloadcms/ui/shared',
]
